import React from 'react'
import {Button, Popconfirm} from "antd";
import {deleteProductionProcess} from "../../services/serviceProductionProcess";
import ProductionProcessUpdate from "./ProductionProcessUpdate";

const ProductionProcessActions = ({record, updater}) => {

    const handleDeleteClick = () => {
        deleteProductionProcess(record.id)
            .then(() => updater())
    }

    return(
        <React.Fragment>
            {/*<ProductionProcessUpdate record={record} />*/}
            <Popconfirm
                title={'Silmek istediğinize emin misiniz ?'}
                okText={'SİL'}
                cancelText={'VAZGEÇ'}
                okButtonProps={{type: 'danger'}}
                onConfirm={handleDeleteClick}
            >
                <Button type={"link"} danger>
                    Sil
                </Button>
            </Popconfirm>
        </React.Fragment>
    )
}
export default ProductionProcessActions